module.exports = __webpack_public_path__ + "img/ico-plan-personal.ef60f932.svg";